import { render, staticRenderFns } from "./DispoForm.vue?vue&type=template&id=0fd5b517"
import script from "./DispoForm.vue?vue&type=script&lang=js"
export * from "./DispoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd5b517')) {
      api.createRecord('0fd5b517', component.options)
    } else {
      api.reload('0fd5b517', component.options)
    }
    module.hot.accept("./DispoForm.vue?vue&type=template&id=0fd5b517", function () {
      api.rerender('0fd5b517', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/additionalCharge/components/DispoForm.vue"
export default component.exports